import ax from '@utils/axios'
import { useGeneralStore } from '@stores/general'
import { useUserStore } from '@stores/users'

async function fetchAdMetricsReports({isSharedView, dateRange, partnerIds, campaignIds}) {
  const generalStore = useGeneralStore()
  const userStore = useUserStore()
  if (campaignIds?.length) {
    this.partnerCategories = []
  }
  if (partnerIds?.length) {
    this.partnerCampaignCategories = []
  }

  // TODO: this needs to be updated to automatically use the query params object for axios
  // generateQueryParams
  try {
    this.showAdMetricsLoadingIndicator = true
    let queryParams = ''
    if (userStore.user.role === 'vendor') {
      if (Object.keys(generalStore.selectedTags)?.length) {
        queryParams = `tag_ids=${generalStore.selectedTags.map((tag) => tag.id).join(',')}`
      } 
      if (partnerIds?.length) {
        queryParams += `&partner_ids=${partnerIds}`
      } 
    } else if (isSharedView) {
      if (partnerIds?.length) {
        queryParams += `&partner_ids=${partnerIds}`
      } 
    } else {
      queryParams = `partner_id=${userStore.partnerId}`
    }
    if (campaignIds?.length) {
      queryParams += `&campaign_ids=${campaignIds}`
    }

    // if startDate and endDate are set, append them to queryParams
    if (dateRange) {
      // Parse dateRange.from (format YYY/MM/DD) and convert it to a date
      const fromDate = new Date(dateRange[0])
      const toDate = new Date(dateRange[1])

      let from = fromDate.toISOString()
      let to = toDate.toISOString()

      queryParams += `&start_date=${from}&end_date=${to}`
    }
    const reportsPath = isSharedView ? 
      (dateRange ?
        `/v2/reports/ad-metrics/salesforce/data/time-filtered?${queryParams}` :
        `/v2/reports/ad-metrics/salesforce/data?${queryParams}`
      ) :
      (dateRange ?
        `/v2/reports/ad-metrics/time-filtered?${queryParams}` :
        `/v2/reports/ad-metrics/?${queryParams}`
      )
    const { data } = await ax.get(reportsPath)

    this.campaignReport = Object.values(data.campaign_report).map((value) => value)
    this.reportTotals = data.totals

    if (data.partner_report) {
      this.partnerReport = Object.values(data.partner_report).map((value) => value)
    }
    if (data.all_report) {
      this.allReport = Object.values(data.all_report).map((value) => value)

      for (let key in data.all_report) {
        const [ partnerId, campaignId ] = key.split('_')
        if (!this.partnerCategories.find((partner) => partner.value === partnerId)) {
          this.partnerCategories.push({ label: data.all_report[key].partner_name, value: partnerId })
        }
        if (!this.partnerCampaignCategories.find((campaign) => campaign.value === campaignId)) {
          this.partnerCampaignCategories.push({ label: data.all_report[key].campaign_name, value: campaignId })
        }
      }
    } else {
      for (let key in data.campaign_report) {
        const campaignId = key
        if (!this.partnerCampaignCategories.find((campaign) => campaign.value === campaignId)) {
          this.partnerCampaignCategories.push({ label: data.campaign_report[key].campaign_name, value: campaignId })
        }
      }
    }

    // sort partnerCategories by label
    this.partnerCategories.sort((a, b) => {
      if (a.label < b.label) {
        return -1
      }
      if (a.label > b.label) {
        return 1
      }
      return 0
    })
    // sort partnerCampaignCategories by label
    this.partnerCampaignCategories.sort((a, b) => {
      if (a.label < b.label) {
        return -1
      }
      if (a.label > b.label) {
        return 1
      }
      return 0
    })

  } catch(error) {
    console.error('There was a problem fetching reports', error)
  }
  finally {
    this.showAdMetricsLoadingIndicator = false
  }
}

async function fetchAdMetricsChartData({dateRange, partnerIds, campaignIds, adMetric}) {
  const userStore = useUserStore()
  const generalStore = useGeneralStore()

  try {
    this.showAdMetricsChartDataLoadingIndicator = true
    let queryParams = ''
    if (userStore.user.role === 'vendor') {
      if (Object.keys(generalStore.selectedTags)?.length) {
        queryParams = `tag_ids=${generalStore.selectedTags.map((tag) => tag.id).join(',')}`
      } 

      if (partnerIds?.length) {
        queryParams += `&partner_ids=${partnerIds}`
      }
    } else {
      queryParams = `partner_id=${userStore.partnerId}`
    }

    if (campaignIds?.length) {
      queryParams += `&campaign_ids=${campaignIds}`
    }

    if (adMetric) {
      queryParams += `&ad_metric=${adMetric}`
    }

    // if startDate and endDate are set, append them to queryParams
    if (dateRange) {
      // Parse dateRange.from (format YYY/MM/DD) and convert it to a date
      const fromDate = new Date(dateRange[0])
      const toDate = new Date(dateRange[1])

      let from = fromDate.toISOString()
      let to = toDate.toISOString()

      queryParams += `&start_date=${from}&end_date=${to}`
    }

    const reportsPath = `/v2/reports/ad-metrics/base-ad-day-metrics?${queryParams}`
    const { data } = await ax.get(reportsPath)
    this.adMetricsChartData = data
  } catch(error) {
    console.error('There was a problem fetching chart metrics', error)
  }
  finally {
    this.showAdMetricsChartDataLoadingIndicator = false
  }
}

export default {
  fetchAdMetricsReports,
  fetchAdMetricsChartData,
}
